import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    insNumOidTypeChip: {
        background: theme.palette.typography.main,
        '& .MuiChip-label': {
            color: '#ffffff',
            lineHeight: '100%',
            transform: 'translateY(0.06rem)',
        },
    },
}))
